<template>
  <iconsWrapper :width="width" :height="height" :viewBox="viewBox">
    <path
      d="M24.0137 25.3874C21.7689 27.3737 18.7926 28.5801 15.5137 28.5801C12.2347 28.5801 9.25848 27.3737 7.01367 25.3874C7.13978 24.2419 7.89646 23.1208 9.24587 22.2434C12.7014 20.0256 18.3512 20.0256 21.7815 22.2434C23.1309 23.1208 23.8876 24.2419 24.0137 25.3874Z"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M15.7733 16.3066C15.6879 16.2944 15.5782 16.2944 15.4806 16.3066C13.3343 16.2334 11.627 14.4746 11.627 12.3127C11.627 10.1021 13.4074 8.30664 15.627 8.30664C17.8343 8.30664 19.627 10.1021 19.627 12.3127C19.6148 14.4746 17.9196 16.2334 15.7733 16.3066Z"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M15.667 28.6667C22.8467 28.6667 28.667 22.8464 28.667 15.6667C28.667 8.48705 22.8467 2.66675 15.667 2.66675C8.48729 2.66675 2.66699 8.48705 2.66699 15.6667C2.66699 22.8464 8.48729 28.6667 15.667 28.6667Z"
      :stroke="iconColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />

    />
  </iconsWrapper>
</template>

<script>
import iconsWrapper from '@/components/icons/iconsWrapper.vue';
export default {
  name: 'iconProfile',
  components: {
    iconsWrapper,
  },
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
    viewBox: {
      type: String,
      default: '0 0 32 32',
    },
  },
};
</script>
